/**
 * @ngdoc directive
 * @name directiveMeetingStaff
 * @restrict A
 *
 * @description
 * Directive for meeting container
 *
 * @element ANY
 */
export default function () {
    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        scope: {
            courseId: '=',
            emptySelector: '='
        },
        controller: 'directiveMeetingStaffCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/meetingStaff.js